import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCrmTracking } from '../../hooks/useCrmTracking';

/**
 * Component that automatically tracks all page views in the Club Admin area
 * Should be placed in the ClubAdminLayout to capture all club admin navigation
 *
 * Tracks all club-admin routes for club admin CRM analytics
 */
export function CrmPageTracker() {
  const location = useLocation();
  const { trackPageView } = useCrmTracking();

  useEffect(() => {
    // Only track club-admin routes
    if (location.pathname.startsWith('/club-admin')) {
      trackPageView(location.pathname);

      // Debug logging in development
      if (import.meta.env.DEV) {
        console.log(`Club Admin Analytics: Tracking page view - ${location.pathname}`);
      }
    }

  }, [location.pathname, trackPageView]);

  // This component renders nothing - it's just for side effects
  return null;
}

/**
 * Higher-order component that wraps a component with CRM tracking
 * Alternative approach if you want to add tracking to specific routes
 */
export function withCrmTracking<T extends object>(
  WrappedComponent: React.ComponentType<T>
) {
  return function CrmTrackedComponent(props: T) {
    return (
      <>
        <CrmPageTracker />
        <WrappedComponent {...props} />
      </>
    );
  };
}